module.exports = __webpack_public_path__ + "img/img_banner_1_small.857226c6.svg";